import React from 'react';
import { useSelector } from 'react-redux';

function formatCellValue(value) {
  if (value === null || value === undefined || value === '') return '-';
  if (Array.isArray(value)) return value.length ? value.join(', ') : '-';
  if (typeof value === 'object') return value.name ?? '-';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value;
}

function TransporterTableContent({ headers }) {
  const transporterListData = useSelector(
    (state) => state.SettingsReducer.transporterList,
  );
  const { transporters } = transporterListData;
  const paddingMode = localStorage.getItem('paddingMode') || 'comfy';

  return (
    <tbody>
      {transporters?.length > 0 ? (
        transporters.map((transporterObj) => (
          <tr
            key={
              transporterObj.business_partner_unique_number ||
              transporterObj.business_partner_id
            }
          >
            {headers.map((header, index) => (
              <td
                className={`table-data ${
                  paddingMode === 'compact'
                    ? 'compact-padding'
                    : 'comfortable-padding'
                }`}
                key={header.value}
              >
                <div className="div-flex-row div-align-center cg-5">
                  {index === 0 && (
                    <input type="checkbox" className="checkbox-grey" />
                  )}
                  {header.value === 'business_partner_name' ? (
                    <button
                      type="button"
                      className="vehicle-master-link-button text-sm-outfit text-medium-bold"
                    >
                      {transporterObj[header.value] ?? '-'}
                    </button>
                  ) : (
                    <span>{formatCellValue(transporterObj[header.value])}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-list-data-message border-bottom">
          <span className="text-sm">No Transporters Found</span>
        </div>
      )}
    </tbody>
  );
}

export default TransporterTableContent;
